import { render, staticRenderFns } from "./ReglementStatusChip.vue?vue&type=template&id=0e30138c"
import script from "./ReglementStatusChip.vue?vue&type=script&lang=js"
export * from "./ReglementStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports